import {
  AsYouType,
  parsePhoneNumberFromString,
  type CountryCode,
} from 'libphonenumber-js';

export const DEFAULT_COUNTRY: CountryCode = 'US';

export type Country = {
  code: string;
  name: string;
  callingCode: string;
  flag: string;
};

export const COUNTRIES: Country[] = [
  { code: 'AF', name: 'Afghanistan', callingCode: '93', flag: '🇦🇫' },
  { code: 'AX', name: 'Åland Islands', callingCode: '358', flag: '🇦🇽' },
  { code: 'AL', name: 'Albania', callingCode: '355', flag: '🇦🇱' },
  { code: 'DZ', name: 'Algeria', callingCode: '213', flag: '🇩🇿' },
  { code: 'AS', name: 'American Samoa', callingCode: '1', flag: '🇦🇸' },
  { code: 'AD', name: 'Andorra', callingCode: '376', flag: '🇦🇩' },
  { code: 'AO', name: 'Angola', callingCode: '244', flag: '🇦🇴' },
  { code: 'AI', name: 'Anguilla', callingCode: '1', flag: '🇦🇮' },
  { code: 'AG', name: 'Antigua & Barbuda', callingCode: '1', flag: '🇦🇬' },
  { code: 'AR', name: 'Argentina', callingCode: '54', flag: '🇦🇷' },
  { code: 'AM', name: 'Armenia', callingCode: '374', flag: '🇦🇲' },
  { code: 'AW', name: 'Aruba', callingCode: '297', flag: '🇦🇼' },
  { code: 'AC', name: 'Ascension Island', callingCode: '247', flag: '🇦🇨' },
  { code: 'AU', name: 'Australia', callingCode: '61', flag: '🇦🇺' },
  { code: 'AT', name: 'Austria', callingCode: '43', flag: '🇦🇹' },
  { code: 'AZ', name: 'Azerbaijan', callingCode: '994', flag: '🇦🇿' },
  { code: 'BS', name: 'Bahamas', callingCode: '1', flag: '🇧🇸' },
  { code: 'BH', name: 'Bahrain', callingCode: '973', flag: '🇧🇭' },
  { code: 'BD', name: 'Bangladesh', callingCode: '880', flag: '🇧🇩' },
  { code: 'BB', name: 'Barbados', callingCode: '1', flag: '🇧🇧' },
  { code: 'BY', name: 'Belarus', callingCode: '375', flag: '🇧🇾' },
  { code: 'BE', name: 'Belgium', callingCode: '32', flag: '🇧🇪' },
  { code: 'BZ', name: 'Belize', callingCode: '501', flag: '🇧🇿' },
  { code: 'BJ', name: 'Benin', callingCode: '229', flag: '🇧🇯' },
  { code: 'BM', name: 'Bermuda', callingCode: '1', flag: '🇧🇲' },
  { code: 'BT', name: 'Bhutan', callingCode: '975', flag: '🇧🇹' },
  { code: 'BO', name: 'Bolivia', callingCode: '591', flag: '🇧🇴' },
  { code: 'BA', name: 'Bosnia & Herzegovina', callingCode: '387', flag: '🇧🇦' },
  { code: 'BW', name: 'Botswana', callingCode: '267', flag: '🇧🇼' },
  { code: 'BR', name: 'Brazil', callingCode: '55', flag: '🇧🇷' },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    callingCode: '246',
    flag: '🇮🇴',
  },
  { code: 'VG', name: 'British Virgin Islands', callingCode: '1', flag: '🇻🇬' },
  { code: 'BN', name: 'Brunei', callingCode: '673', flag: '🇧🇳' },
  { code: 'BG', name: 'Bulgaria', callingCode: '359', flag: '🇧🇬' },
  { code: 'BF', name: 'Burkina Faso', callingCode: '226', flag: '🇧🇫' },
  { code: 'BI', name: 'Burundi', callingCode: '257', flag: '🇧🇮' },
  { code: 'KH', name: 'Cambodia', callingCode: '855', flag: '🇰🇭' },
  { code: 'CM', name: 'Cameroon', callingCode: '237', flag: '🇨🇲' },
  { code: 'CA', name: 'Canada', callingCode: '1', flag: '🇨🇦' },
  { code: 'CV', name: 'Cape Verde', callingCode: '238', flag: '🇨🇻' },
  { code: 'BQ', name: 'Caribbean Netherlands', callingCode: '599', flag: '🇧🇶' },
  { code: 'KY', name: 'Cayman Islands', callingCode: '1', flag: '🇰🇾' },
  {
    code: 'CF',
    name: 'Central African Republic',
    callingCode: '236',
    flag: '🇨🇫',
  },
  { code: 'TD', name: 'Chad', callingCode: '235', flag: '🇹🇩' },
  { code: 'CL', name: 'Chile', callingCode: '56', flag: '🇨🇱' },
  { code: 'CN', name: 'China', callingCode: '86', flag: '🇨🇳' },
  { code: 'CX', name: 'Christmas Island', callingCode: '61', flag: '🇨🇽' },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    callingCode: '61',
    flag: '🇨🇨',
  },
  { code: 'CO', name: 'Colombia', callingCode: '57', flag: '🇨🇴' },
  { code: 'KM', name: 'Comoros', callingCode: '269', flag: '🇰🇲' },
  { code: 'CG', name: 'Congo - Brazzaville', callingCode: '242', flag: '🇨🇬' },
  { code: 'CD', name: 'Congo - Kinshasa', callingCode: '243', flag: '🇨🇩' },
  { code: 'CK', name: 'Cook Islands', callingCode: '682', flag: '🇨🇰' },
  { code: 'CR', name: 'Costa Rica', callingCode: '506', flag: '🇨🇷' },
  { code: 'CI', name: 'Côte d’Ivoire', callingCode: '225', flag: '🇨🇮' },
  { code: 'HR', name: 'Croatia', callingCode: '385', flag: '🇭🇷' },
  { code: 'CU', name: 'Cuba', callingCode: '53', flag: '🇨🇺' },
  { code: 'CW', name: 'Curaçao', callingCode: '599', flag: '🇨🇼' },
  { code: 'CY', name: 'Cyprus', callingCode: '357', flag: '🇨🇾' },
  { code: 'CZ', name: 'Czechia', callingCode: '420', flag: '🇨🇿' },
  { code: 'DK', name: 'Denmark', callingCode: '45', flag: '🇩🇰' },
  { code: 'DJ', name: 'Djibouti', callingCode: '253', flag: '🇩🇯' },
  { code: 'DM', name: 'Dominica', callingCode: '1', flag: '🇩🇲' },
  { code: 'DO', name: 'Dominican Republic', callingCode: '1', flag: '🇩🇴' },
  { code: 'EC', name: 'Ecuador', callingCode: '593', flag: '🇪🇨' },
  { code: 'EG', name: 'Egypt', callingCode: '20', flag: '🇪🇬' },
  { code: 'SV', name: 'El Salvador', callingCode: '503', flag: '🇸🇻' },
  { code: 'GQ', name: 'Equatorial Guinea', callingCode: '240', flag: '🇬🇶' },
  { code: 'ER', name: 'Eritrea', callingCode: '291', flag: '🇪🇷' },
  { code: 'EE', name: 'Estonia', callingCode: '372', flag: '🇪🇪' },
  { code: 'SZ', name: 'Eswatini', callingCode: '268', flag: '🇸🇿' },
  { code: 'ET', name: 'Ethiopia', callingCode: '251', flag: '🇪🇹' },
  { code: 'FK', name: 'Falkland Islands', callingCode: '500', flag: '🇫🇰' },
  { code: 'FO', name: 'Faroe Islands', callingCode: '298', flag: '🇫🇴' },
  { code: 'FJ', name: 'Fiji', callingCode: '679', flag: '🇫🇯' },
  { code: 'FI', name: 'Finland', callingCode: '358', flag: '🇫🇮' },
  { code: 'FR', name: 'France', callingCode: '33', flag: '🇫🇷' },
  { code: 'GF', name: 'French Guiana', callingCode: '594', flag: '🇬🇫' },
  { code: 'PF', name: 'French Polynesia', callingCode: '689', flag: '🇵🇫' },
  { code: 'GA', name: 'Gabon', callingCode: '241', flag: '🇬🇦' },
  { code: 'GM', name: 'Gambia', callingCode: '220', flag: '🇬🇲' },
  { code: 'GE', name: 'Georgia', callingCode: '995', flag: '🇬🇪' },
  { code: 'DE', name: 'Germany', callingCode: '49', flag: '🇩🇪' },
  { code: 'GH', name: 'Ghana', callingCode: '233', flag: '🇬🇭' },
  { code: 'GI', name: 'Gibraltar', callingCode: '350', flag: '🇬🇮' },
  { code: 'GR', name: 'Greece', callingCode: '30', flag: '🇬🇷' },
  { code: 'GL', name: 'Greenland', callingCode: '299', flag: '🇬🇱' },
  { code: 'GD', name: 'Grenada', callingCode: '1', flag: '🇬🇩' },
  { code: 'GP', name: 'Guadeloupe', callingCode: '590', flag: '🇬🇵' },
  { code: 'GU', name: 'Guam', callingCode: '1', flag: '🇬🇺' },
  { code: 'GT', name: 'Guatemala', callingCode: '502', flag: '🇬🇹' },
  { code: 'GG', name: 'Guernsey', callingCode: '44', flag: '🇬🇬' },
  { code: 'GN', name: 'Guinea', callingCode: '224', flag: '🇬🇳' },
  { code: 'GW', name: 'Guinea-Bissau', callingCode: '245', flag: '🇬🇼' },
  { code: 'GY', name: 'Guyana', callingCode: '592', flag: '🇬🇾' },
  { code: 'HT', name: 'Haiti', callingCode: '509', flag: '🇭🇹' },
  { code: 'HN', name: 'Honduras', callingCode: '504', flag: '🇭🇳' },
  { code: 'HK', name: 'Hong Kong SAR China', callingCode: '852', flag: '🇭🇰' },
  { code: 'HU', name: 'Hungary', callingCode: '36', flag: '🇭🇺' },
  { code: 'IS', name: 'Iceland', callingCode: '354', flag: '🇮🇸' },
  { code: 'IN', name: 'India', callingCode: '91', flag: '🇮🇳' },
  { code: 'ID', name: 'Indonesia', callingCode: '62', flag: '🇮🇩' },
  { code: 'IR', name: 'Iran', callingCode: '98', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraq', callingCode: '964', flag: '🇮🇶' },
  { code: 'IE', name: 'Ireland', callingCode: '353', flag: '🇮🇪' },
  { code: 'IM', name: 'Isle of Man', callingCode: '44', flag: '🇮🇲' },
  { code: 'IL', name: 'Israel', callingCode: '972', flag: '🇮🇱' },
  { code: 'IT', name: 'Italy', callingCode: '39', flag: '🇮🇹' },
  { code: 'JM', name: 'Jamaica', callingCode: '1', flag: '🇯🇲' },
  { code: 'JP', name: 'Japan', callingCode: '81', flag: '🇯🇵' },
  { code: 'JE', name: 'Jersey', callingCode: '44', flag: '🇯🇪' },
  { code: 'JO', name: 'Jordan', callingCode: '962', flag: '🇯🇴' },
  { code: 'KZ', name: 'Kazakhstan', callingCode: '7', flag: '🇰🇿' },
  { code: 'KE', name: 'Kenya', callingCode: '254', flag: '🇰🇪' },
  { code: 'KI', name: 'Kiribati', callingCode: '686', flag: '🇰🇮' },
  { code: 'XK', name: 'Kosovo', callingCode: '383', flag: '🇽🇰' },
  { code: 'KW', name: 'Kuwait', callingCode: '965', flag: '🇰🇼' },
  { code: 'KG', name: 'Kyrgyzstan', callingCode: '996', flag: '🇰🇬' },
  { code: 'LA', name: 'Laos', callingCode: '856', flag: '🇱🇦' },
  { code: 'LV', name: 'Latvia', callingCode: '371', flag: '🇱🇻' },
  { code: 'LB', name: 'Lebanon', callingCode: '961', flag: '🇱🇧' },
  { code: 'LS', name: 'Lesotho', callingCode: '266', flag: '🇱🇸' },
  { code: 'LR', name: 'Liberia', callingCode: '231', flag: '🇱🇷' },
  { code: 'LY', name: 'Libya', callingCode: '218', flag: '🇱🇾' },
  { code: 'LI', name: 'Liechtenstein', callingCode: '423', flag: '🇱🇮' },
  { code: 'LT', name: 'Lithuania', callingCode: '370', flag: '🇱🇹' },
  { code: 'LU', name: 'Luxembourg', callingCode: '352', flag: '🇱🇺' },
  { code: 'MO', name: 'Macao SAR China', callingCode: '853', flag: '🇲🇴' },
  { code: 'MG', name: 'Madagascar', callingCode: '261', flag: '🇲🇬' },
  { code: 'MW', name: 'Malawi', callingCode: '265', flag: '🇲🇼' },
  { code: 'MY', name: 'Malaysia', callingCode: '60', flag: '🇲🇾' },
  { code: 'MV', name: 'Maldives', callingCode: '960', flag: '🇲🇻' },
  { code: 'ML', name: 'Mali', callingCode: '223', flag: '🇲🇱' },
  { code: 'MT', name: 'Malta', callingCode: '356', flag: '🇲🇹' },
  { code: 'MH', name: 'Marshall Islands', callingCode: '692', flag: '🇲🇭' },
  { code: 'MQ', name: 'Martinique', callingCode: '596', flag: '🇲🇶' },
  { code: 'MR', name: 'Mauritania', callingCode: '222', flag: '🇲🇷' },
  { code: 'MU', name: 'Mauritius', callingCode: '230', flag: '🇲🇺' },
  { code: 'YT', name: 'Mayotte', callingCode: '262', flag: '🇾🇹' },
  { code: 'MX', name: 'Mexico', callingCode: '52', flag: '🇲🇽' },
  { code: 'FM', name: 'Micronesia', callingCode: '691', flag: '🇫🇲' },
  { code: 'MD', name: 'Moldova', callingCode: '373', flag: '🇲🇩' },
  { code: 'MC', name: 'Monaco', callingCode: '377', flag: '🇲🇨' },
  { code: 'MN', name: 'Mongolia', callingCode: '976', flag: '🇲🇳' },
  { code: 'ME', name: 'Montenegro', callingCode: '382', flag: '🇲🇪' },
  { code: 'MS', name: 'Montserrat', callingCode: '1', flag: '🇲🇸' },
  { code: 'MA', name: 'Morocco', callingCode: '212', flag: '🇲🇦' },
  { code: 'MZ', name: 'Mozambique', callingCode: '258', flag: '🇲🇿' },
  { code: 'MM', name: 'Myanmar (Burma)', callingCode: '95', flag: '🇲🇲' },
  { code: 'NA', name: 'Namibia', callingCode: '264', flag: '🇳🇦' },
  { code: 'NR', name: 'Nauru', callingCode: '674', flag: '🇳🇷' },
  { code: 'NP', name: 'Nepal', callingCode: '977', flag: '🇳🇵' },
  { code: 'NL', name: 'Netherlands', callingCode: '31', flag: '🇳🇱' },
  { code: 'NC', name: 'New Caledonia', callingCode: '687', flag: '🇳🇨' },
  { code: 'NZ', name: 'New Zealand', callingCode: '64', flag: '🇳🇿' },
  { code: 'NI', name: 'Nicaragua', callingCode: '505', flag: '🇳🇮' },
  { code: 'NE', name: 'Niger', callingCode: '227', flag: '🇳🇪' },
  { code: 'NG', name: 'Nigeria', callingCode: '234', flag: '🇳🇬' },
  { code: 'NU', name: 'Niue', callingCode: '683', flag: '🇳🇺' },
  { code: 'NF', name: 'Norfolk Island', callingCode: '672', flag: '🇳🇫' },
  { code: 'KP', name: 'North Korea', callingCode: '850', flag: '🇰🇵' },
  { code: 'MK', name: 'North Macedonia', callingCode: '389', flag: '🇲🇰' },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    callingCode: '1',
    flag: '🇲🇵',
  },
  { code: 'NO', name: 'Norway', callingCode: '47', flag: '🇳🇴' },
  { code: 'OM', name: 'Oman', callingCode: '968', flag: '🇴🇲' },
  { code: 'PK', name: 'Pakistan', callingCode: '92', flag: '🇵🇰' },
  { code: 'PW', name: 'Palau', callingCode: '680', flag: '🇵🇼' },
  {
    code: 'PS',
    name: 'Palestinian Territories',
    callingCode: '970',
    flag: '🇵🇸',
  },
  { code: 'PA', name: 'Panama', callingCode: '507', flag: '🇵🇦' },
  { code: 'PG', name: 'Papua New Guinea', callingCode: '675', flag: '🇵🇬' },
  { code: 'PY', name: 'Paraguay', callingCode: '595', flag: '🇵🇾' },
  { code: 'PE', name: 'Peru', callingCode: '51', flag: '🇵🇪' },
  { code: 'PH', name: 'Philippines', callingCode: '63', flag: '🇵🇭' },
  { code: 'PL', name: 'Poland', callingCode: '48', flag: '🇵🇱' },
  { code: 'PT', name: 'Portugal', callingCode: '351', flag: '🇵🇹' },
  { code: 'PR', name: 'Puerto Rico', callingCode: '1', flag: '🇵🇷' },
  { code: 'QA', name: 'Qatar', callingCode: '974', flag: '🇶🇦' },
  { code: 'RE', name: 'Réunion', callingCode: '262', flag: '🇷🇪' },
  { code: 'RO', name: 'Romania', callingCode: '40', flag: '🇷🇴' },
  { code: 'RU', name: 'Russia', callingCode: '7', flag: '🇷🇺' },
  { code: 'RW', name: 'Rwanda', callingCode: '250', flag: '🇷🇼' },
  { code: 'WS', name: 'Samoa', callingCode: '685', flag: '🇼🇸' },
  { code: 'SM', name: 'San Marino', callingCode: '378', flag: '🇸🇲' },
  { code: 'ST', name: 'São Tomé & Príncipe', callingCode: '239', flag: '🇸🇹' },
  { code: 'SA', name: 'Saudi Arabia', callingCode: '966', flag: '🇸🇦' },
  { code: 'SN', name: 'Senegal', callingCode: '221', flag: '🇸🇳' },
  { code: 'RS', name: 'Serbia', callingCode: '381', flag: '🇷🇸' },
  { code: 'SC', name: 'Seychelles', callingCode: '248', flag: '🇸🇨' },
  { code: 'SL', name: 'Sierra Leone', callingCode: '232', flag: '🇸🇱' },
  { code: 'SG', name: 'Singapore', callingCode: '65', flag: '🇸🇬' },
  { code: 'SX', name: 'Sint Maarten', callingCode: '1', flag: '🇸🇽' },
  { code: 'SK', name: 'Slovakia', callingCode: '421', flag: '🇸🇰' },
  { code: 'SI', name: 'Slovenia', callingCode: '386', flag: '🇸🇮' },
  { code: 'SB', name: 'Solomon Islands', callingCode: '677', flag: '🇸🇧' },
  { code: 'SO', name: 'Somalia', callingCode: '252', flag: '🇸🇴' },
  { code: 'ZA', name: 'South Africa', callingCode: '27', flag: '🇿🇦' },
  { code: 'KR', name: 'South Korea', callingCode: '82', flag: '🇰🇷' },
  { code: 'SS', name: 'South Sudan', callingCode: '211', flag: '🇸🇸' },
  { code: 'ES', name: 'Spain', callingCode: '34', flag: '🇪🇸' },
  { code: 'LK', name: 'Sri Lanka', callingCode: '94', flag: '🇱🇰' },
  { code: 'BL', name: 'St. Barthélemy', callingCode: '590', flag: '🇧🇱' },
  { code: 'SH', name: 'St. Helena', callingCode: '290', flag: '🇸🇭' },
  { code: 'KN', name: 'St. Kitts & Nevis', callingCode: '1', flag: '🇰🇳' },
  { code: 'LC', name: 'St. Lucia', callingCode: '1', flag: '🇱🇨' },
  { code: 'MF', name: 'St. Martin', callingCode: '590', flag: '🇲🇫' },
  { code: 'PM', name: 'St. Pierre & Miquelon', callingCode: '508', flag: '🇵🇲' },
  {
    code: 'VC',
    name: 'St. Vincent & Grenadines',
    callingCode: '1',
    flag: '🇻🇨',
  },
  { code: 'SD', name: 'Sudan', callingCode: '249', flag: '🇸🇩' },
  { code: 'SR', name: 'Suriname', callingCode: '597', flag: '🇸🇷' },
  { code: 'SJ', name: 'Svalbard & Jan Mayen', callingCode: '47', flag: '🇸🇯' },
  { code: 'SE', name: 'Sweden', callingCode: '46', flag: '🇸🇪' },
  { code: 'CH', name: 'Switzerland', callingCode: '41', flag: '🇨🇭' },
  { code: 'SY', name: 'Syria', callingCode: '963', flag: '🇸🇾' },
  { code: 'TW', name: 'Taiwan', callingCode: '886', flag: '🇹🇼' },
  { code: 'TJ', name: 'Tajikistan', callingCode: '992', flag: '🇹🇯' },
  { code: 'TZ', name: 'Tanzania', callingCode: '255', flag: '🇹🇿' },
  { code: 'TH', name: 'Thailand', callingCode: '66', flag: '🇹🇭' },
  { code: 'TL', name: 'Timor-Leste', callingCode: '670', flag: '🇹🇱' },
  { code: 'TG', name: 'Togo', callingCode: '228', flag: '🇹🇬' },
  { code: 'TK', name: 'Tokelau', callingCode: '690', flag: '🇹🇰' },
  { code: 'TO', name: 'Tonga', callingCode: '676', flag: '🇹🇴' },
  { code: 'TT', name: 'Trinidad & Tobago', callingCode: '1', flag: '🇹🇹' },
  { code: 'TA', name: 'Tristan da Cunha', callingCode: '290', flag: '🇹🇦' },
  { code: 'TN', name: 'Tunisia', callingCode: '216', flag: '🇹🇳' },
  { code: 'TR', name: 'Türkiye', callingCode: '90', flag: '🇹🇷' },
  { code: 'TM', name: 'Turkmenistan', callingCode: '993', flag: '🇹🇲' },
  { code: 'TC', name: 'Turks & Caicos Islands', callingCode: '1', flag: '🇹🇨' },
  { code: 'TV', name: 'Tuvalu', callingCode: '688', flag: '🇹🇻' },
  { code: 'VI', name: 'U.S. Virgin Islands', callingCode: '1', flag: '🇻🇮' },
  { code: 'UG', name: 'Uganda', callingCode: '256', flag: '🇺🇬' },
  { code: 'UA', name: 'Ukraine', callingCode: '380', flag: '🇺🇦' },
  { code: 'AE', name: 'United Arab Emirates', callingCode: '971', flag: '🇦🇪' },
  { code: 'GB', name: 'United Kingdom', callingCode: '44', flag: '🇬🇧' },
  { code: 'US', name: 'United States', callingCode: '1', flag: '🇺🇸' },
  { code: 'UY', name: 'Uruguay', callingCode: '598', flag: '🇺🇾' },
  { code: 'UZ', name: 'Uzbekistan', callingCode: '998', flag: '🇺🇿' },
  { code: 'VU', name: 'Vanuatu', callingCode: '678', flag: '🇻🇺' },
  { code: 'VA', name: 'Vatican City', callingCode: '39', flag: '🇻🇦' },
  { code: 'VE', name: 'Venezuela', callingCode: '58', flag: '🇻🇪' },
  { code: 'VN', name: 'Vietnam', callingCode: '84', flag: '🇻🇳' },
  { code: 'WF', name: 'Wallis & Futuna', callingCode: '681', flag: '🇼🇫' },
  { code: 'EH', name: 'Western Sahara', callingCode: '212', flag: '🇪🇭' },
  { code: 'YE', name: 'Yemen', callingCode: '967', flag: '🇾🇪' },
  { code: 'ZM', name: 'Zambia', callingCode: '260', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbabwe', callingCode: '263', flag: '🇿🇼' },
];

// pinned to the top of the picker since most users are here
const PINNED_CODES = ['US', 'CA'];

const PINNED_COUNTRIES = PINNED_CODES.map((code) =>
  COUNTRIES.find((c) => c.code === code)
) as Country[];

const UNPINNED_COUNTRIES = COUNTRIES.filter(
  (c) => !PINNED_CODES.includes(c.code)
);

export const ORDERED_COUNTRIES = [...PINNED_COUNTRIES, ...UNPINNED_COUNTRIES];

export const findCountry = (code: string): Country | undefined =>
  COUNTRIES.find((c) => c.code === code);

export const DEFAULT_COUNTRY_INFO: Country = findCountry(DEFAULT_COUNTRY) ?? {
  code: 'US',
  name: 'United States',
  callingCode: '1',
  flag: '🇺🇸',
};

export const digitsOnly = (input: string): string => input.replace(/\D/g, '');

/** Digits from phone-like text, or undefined when letters are mixed in. */
export const phoneLikeDigits = (input: string): string | undefined => {
  // reject before stripping so "Player 5" is not treated as the digit 5
  if (!/^[\d\s\-+().]*$/.test(input)) {
    return undefined;
  }

  const digits = digitsOnly(input);
  return digits || undefined;
};

// formats digits into the country's national style as the user types
export const formatNational = (input: string, country: string): string =>
  new AsYouType(country as CountryCode).input(digitsOnly(input));

// national digits => E.164 (e.g. "+14155551234"), or null when invalid
export const toE164 = (national: string, country: string): string | null => {
  const parsed = parsePhoneNumberFromString(
    digitsOnly(national),
    country as CountryCode
  );
  return parsed?.isValid() ? parsed.number : null;
};

// stored E.164 => country + national text for editing
export const parseE164 = (
  e164: string
): { country: Country; national: string } | null => {
  const parsed = parsePhoneNumberFromString(e164);
  const country = parsed?.country ? findCountry(parsed.country) : undefined;

  if (!parsed || !country) {
    return null;
  }

  return { country, national: parsed.formatNational() };
};
